import type { ObjectDirective } from '@/composition/vue/compositionApi'
import { TestIdAttrName } from '@/composition/testing/types'

export type TestIdDirectiveBinding = string | undefined

const apply = (el: HTMLElement, value: TestIdDirectiveBinding) => {
  if (value) {
    el.setAttribute(TestIdAttrName, value)
  } else {
    el.removeAttribute(TestIdAttrName)
  }
}

export const testIdDirective: ObjectDirective<HTMLElement, TestIdDirectiveBinding> = {
  mounted(el, binding) {
    apply(el, binding.value)
  },
  updated(el, binding) {
    apply(el, binding.value)
  },
}
